import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import adapter from "./adapter";
import service from "./service";

const initialState = {
  _payload: null,
  status: "idle",
  error: "",
  data: [],
  data_options: [],
};

export const fetchProvinces = createAsyncThunk(
  "provinces/fetchProvinces",
  async () => {
    const data = await service.getData();
    return data;
  }
);

export const provincesSlice = createSlice({
  name: "provinces",
  initialState,
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
  },
  extraReducers: {
    [fetchProvinces.pending]: (state) => {
      state.status = "loading";
    },
    [fetchProvinces.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      // const payload = adapter.responseBodyToRender(action.payload);
      state.data = action.payload;
      state.data_options = matchOptions(action.payload)
    },
    [fetchProvinces.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
  },
});

function matchOptions(payload) {
  let result = [];

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index];
      result.push({
        label: element.provinsi,
        value: element.provinsi
      })
    }
  }

  return result
}

export const { setStatus } = provincesSlice.actions

export default provincesSlice.reducer;
